import { Modal } from 'bootstrap';
import { create as createCookie } from '../utils/cookies';

export default class CookiesNotice {
  /**
   * @param cookieNotice {HTMLElement|null}
   * @param modal {HTMLElement}
   */
  constructor(cookieNotice, modal) {
    this.dom = {
      cookieNotice,
      modal,
      form: modal.querySelector('#cookie-notice-form'),
      triggers: [...(cookieNotice ? cookieNotice.querySelectorAll('.js-cookie-trigger') : []), ...modal.querySelectorAll('.js-cookie-trigger')],
    };

    this.data = {
      cookieDuration: 30,
      completedClass: 'is-loading',
      htmlDisableScrollClass: 'overflow-hidden',
      acceptAllCookies: 'accept-all-cookies',
      rejectAllCookies: 'reject-all-cookies',
    };

    this.components = {
      modal: null,
    };

    this.events = {
      onTriggerClick: this.onTriggerClick.bind(this),
      onModalHidden: this.onModalHidden.bind(this),
    };
  }

  /**
   * @return {this}
   */
  mount() {
    if (this.dom.cookieNotice) {
      // Remove completed class
      this.dom.cookieNotice.classList.remove(this.data.completedClass);
      // Disallow scroll
      document.documentElement.classList.add(this.data.htmlDisableScrollClass);
    }

    this.dom.triggers.forEach((trigger) => {
      trigger.addEventListener('click', this.events.onTriggerClick);
    });

    return this;
  }

  /**
   * Remove cookie notice from DOM
   *
   * @return {this}
   */
  destroy() {
    if (this.dom.cookieNotice) {
      this.dom.cookieNotice.remove();
      this.dom.cookieNotice = null;
    }

    return this;
  }

  /**
   * Set to completed state
   *
   * @return {this}
   */
  setCompletedState() {
    if (this.dom.cookieNotice) {
      // Hide the notice
      this.dom.cookieNotice.classList.add(this.data.completedClass);
    }

    // Remove the disabled scrolling from the HTML-element
    document.documentElement.classList.remove(this.data.htmlDisableScrollClass);

    return this;
  }

  /**
   * Set cookie
   *
   * @param action {String}
   */
  setCookies(action) {
    if (this.dom.modal) {
      this.components.modal = Modal.getInstance(this.dom.modal);
    }

    // Select all available privacy settings
    [...this.dom.modal.querySelectorAll('[name^="Cookies["]:not(:disabled)')].forEach((checkbox) => {
      const cookieName = checkbox.getAttribute('data-key');
      // Set value based on accept all or the checked state
      let value = +checkbox.checked;

      if (action === this.data.acceptAllCookies) {
        value = 1;
      } else if (action === this.data.rejectAllCookies) {
        value = 0;
      }

      // eslint-disable-next-line no-param-reassign
      checkbox.checked = value; // Update the checkbox based on the value

      // Save the privacy setting
      createCookie({ name: cookieName, value, days: this.data.cookieDuration });
    });

    // Save the selected cookie state
    createCookie({ name: 'cookies_selected', value: 1, days: this.data.cookieDuration });

    if (this.components.modal) {
      this.dom.modal.addEventListener('hidden.bs.modal', this.events.onModalHidden);
      this.components.modal.hide();
    } else {
      this.setCompletedState();
      // all done, remove from dom
      this.destroy();
    }
  }

  /**
   * @param event {Event}
   */
  onTriggerClick(event) {
    event.preventDefault();

    const { target } = event;
    const action = target.dataset.name;

    this.setCookies(action);
  }

  /**
   * Event is fired when the modal has finished being hidden from the user
   * (will wait for CSS transitions to complete).
   */
  onModalHidden() {
    this.dom.modal.removeEventListener('hidden.bs.modal', this.events.onModalHidden);
    this.components.modal.dispose();
    this.setCompletedState();
    this.destroy();
  }
}
